import { type MutationError, trpc } from '@/shared/api';

interface UseRenameFontOptions {
  readonly onSuccess?: () => void;
}

/** 폰트 이름 수정 — 형식·파일은 바꿀 수 없고 이름만 고친다. 살아 있는 폰트와 겹치면 서버가 409 로 거부한다. */
export const useRenameFont = ({ onSuccess }: UseRenameFontOptions = {}) => {
  const mutation = trpc.productManagement.fonts.rename.useMutation({ onSuccess });

  const error: MutationError | null = mutation.error;

  return {
    renameFont: mutation.mutate,
    /** 저장이 진행 중인 폰트 id — 진행 표시를 해당 행에만 스코프한다. */
    pendingId: mutation.isPending ? (mutation.variables?.id ?? null) : null,
    isPending: mutation.isPending,
    error,
    /** 지난 오류를 지운다 — 같은 오류 줄을 쓰는 다른 요청을 시작할 때 옛 오류가 남지 않게. */
    reset: mutation.reset,
  };
};
